import React from 'react'

const ResetEmailSent = () => {
  return (
    <div>
        <h1>Reset Email sent!</h1>
        <p>Check your email to reset your password</p>
    </div>
  )
}

export default ResetEmailSent